var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"no-shadow":_vm.no_shadow}},[_c('vx-timeline',{attrs:{"timelineData":_vm.timelineData}}),(_vm.timelineMeta.has_next)?_c('infinite-loading',{attrs:{"spinner":"circles"},on:{"infinite":_vm.getMoreActivityLog}},[_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }